import { initSwiper } from '@resources/js/components/initSwiper.js';
import addSlidesToSlider from '@resources/js/helpers/addSlidesToSlider';
import inViewport from '@resources/js/helpers/inViewport';
import { isDesktop } from '@resources/js/helpers/media';
import Tabs from '@resources/js/ui/Tabs';
const PHOTO_IMAGE_SIZE = { width: 578, height: 462 };
const roomsSectionElement = document.querySelector('.js-hotel-rooms');
const initializedSliders = new WeakSet();
// лічильник «1/N»; N береться з data-photo-total,
// бо у слайдері спочатку лише частина фото
const initCounter = (panelElement, sliderElement) => {
    const counterElement = panelElement.querySelector('.js-room-photos-counter');
    const { photoTotal } = sliderElement.dataset;
    sliderElement.addEventListener('swiperslidechange', (event) => {
        const [{ realIndex }] = event.detail;
        counterElement.textContent = `${realIndex + 1}/${photoTotal}`;
    });
};
const initPhotoSlider = (panelElement) => {
    const sliderElement = panelElement.querySelector('.js-room-photos-slider');
    if (!sliderElement || initializedSliders.has(sliderElement))
        return;
    initializedSliders.add(sliderElement);
    initCounter(panelElement, sliderElement);
    initSwiper(sliderElement, {
        spaceBetween: 0,
        loop: false,
        navigation: {
            prevEl: panelElement.querySelector('.js-room-photos-prev'),
            nextEl: panelElement.querySelector('.js-room-photos-next'),
        },
        pagination: {
            el: panelElement.querySelector('.js-room-photos-pagination'),
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 2,
        },
    });
    // решту фото дозавантажуємо після першого гортання, щоб не роздувати HTML
    sliderElement.swiper.once('slideChange', () => addSlidesToSlider(sliderElement, PHOTO_IMAGE_SIZE));
};
// таби — swiper-container з розмітки; на десктопі він вимкнений, там працює CSS-грід
const initTabsSlider = (sliderElement) => {
    initSwiper(sliderElement, {
        enabled: !isDesktop(),
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        scrollbar: {
            draggable: true,
        },
    });
};
inViewport(roomsSectionElement, () => {
    const tabsElement = roomsSectionElement.querySelector('.js-room-tabs');
    const activePanelElement = roomsSectionElement.querySelector('.js-room-panel.active');
    initPhotoSlider(activePanelElement);
    // табів немає, якщо кімната лише одна
    if (!tabsElement)
        return;
    initTabsSlider(tabsElement);
    const tabs = new Tabs(tabsElement);
    tabs.on('change', ({ target }) => initPhotoSlider(target));
});
